module.exports = __webpack_public_path__ + "img/otto-data.e430eb53.webp";